import { api } from '@/middleware/api';
import { publicationRequest, publicationError, moscowInput, moscowSchedule, scheduledDisplayDate } from '@/services/publication-schedule.mjs';
import { requestSsgPublication, getSsgPublicationStatus } from '@/services/ssg-publication.service';

export default {
  data() { return { scheduleRecord: { state: 'DRAFT', version: 0 }, scheduleInput: '', scheduleBusy: false,
    scheduleNotice: '', scheduleEntityId: null, scheduleTimer: null, scheduleLegacyRequest: null }; },
  computed: { scheduleLocked() { return ['PUBLISHING', 'FAILED'].includes(this.scheduleRecord.state); } },
  beforeUnmount() { clearInterval(this.scheduleTimer); },
  methods: {
    async initSchedule(id) {
      this.scheduleEntityId = id ? Number(id) : null;
      if (id) {
        await this.refreshSchedule();
        this.scheduleInput = moscowInput(this.scheduleRecord.scheduledAt);
      }
      this.scheduleTimer = setInterval(() => {
        if (!this.scheduleBusy && this.scheduleEntityId) this.refreshSchedule().catch(() => {
          this.scheduleNotice = 'Не удалось обновить статус. Не создавайте материал повторно.';
        });
      }, 5000);
    },
    async refreshSchedule() {
      this.scheduleRecord = await publicationRequest(api, this.publicationKind, this.scheduleEntityId);
      if (this.scheduleLegacyRequest) {
        const { path, requestedAt } = this.scheduleLegacyRequest;
        const status = await getSsgPublicationStatus(api, path, requestedAt);
        if (status.ready) { this.scheduleNotice = 'Изменения сохранены; обновлённая страница подтверждена.'; this.scheduleLegacyRequest = null; }
        else this.scheduleNotice = 'Изменения сохранены, обновление страницы ещё не подтверждено. Повторно сохранять не нужно.';
      }
    },
    async scheduleAction(action) {
      if (this.scheduleBusy) return;
      this.scheduleBusy = true;
      this.scheduleNotice = '';
      let saved = false;
      try {
        // Validate time before cancelling an existing schedule or saving files.
        const scheduledAt = action === 'schedule' ? moscowSchedule(this.scheduleInput) : undefined;
        if (['cancel', 'retry'].includes(action)) {
          this.scheduleRecord = await publicationRequest(api, this.publicationKind, this.scheduleEntityId,
            { action, version: this.scheduleRecord.version });
          this.scheduleNotice = action === 'cancel' ? 'Расписание отменено. Материал остался черновиком.' : 'Повтор публикации запрошен. Дубликат не создаётся.';
          return;
        }
        if (this.scheduleLocked) throw new Error('Публикация уже началась. Изменения временно заблокированы.');
        if (!this.editorValidation.valid) throw new Error(this.editorValidation.message);
        const { valid } = await this.$refs.formMaterialBlock.validate();
        if (!valid) throw new Error('Проверьте обязательные поля формы');
        if (this.scheduleRecord.state === 'SCHEDULED') {
          this.scheduleRecord = await publicationRequest(api, this.publicationKind, this.scheduleEntityId,
            { action: 'cancel', version: this.scheduleRecord.version });
          this.scheduleNotice = 'Расписание снято на время сохранения. При ошибке материал останется черновиком.';
        }
        const alreadyPublished = this.scheduleRecord.state === 'PUBLISHED';
        if (scheduledAt && !this.publicationDisplayDate()) this.setPublicationDisplayDate(scheduledDisplayDate(scheduledAt));
        const item = await this.savePublicationDraft();
        this.scheduleEntityId = item.id;
        saved = true;
        await this.refreshSchedule();
        if (alreadyPublished) {
          const path = `/${this.publicationKind === 'materials' ? 'materials' : 'academy'}/${item.url}`;
          const request = await requestSsgPublication(api, path);
          this.scheduleLegacyRequest = { path, requestedAt: request.requestedAt };
          this.scheduleNotice = 'Изменения сохранены. Ждём подтверждения обновлённой страницы.';
        } else if (action === 'draft') {
          this.scheduleNotice = 'Черновик сохранён. На сайте он не опубликован.';
        } else {
          this.scheduleRecord = await publicationRequest(api, this.publicationKind, item.id,
            { action, version: this.scheduleRecord.version, ...(scheduledAt ? { scheduledAt } : {}) });
          this.scheduleNotice = action === 'schedule' ? 'Расписание сохранено. Админку можно закрыть.' : 'Публикация запрошена. Админку можно закрыть.';
        }
      } catch (error) {
        const prefix = saved ? `Изменения материала #${this.scheduleEntityId} сохранены. `
          : this.scheduleEntityId ? `Запись #${this.scheduleEntityId} уже существует; повторно создавать её не нужно. Последние изменения могли не сохраниться. ` : '';
        this.scheduleNotice = prefix + publicationError(error);
        this.alertError(this.scheduleNotice);
        if (this.scheduleEntityId) await this.refreshSchedule().catch(() => {});
      } finally {
        this.scheduleBusy = false;
        this.IS_GLOBAL_LOADING(false);
        if (this.scheduleEntityId && !this.$route.params.id) {
          await this.$router.replace({ name: this.publicationKind === 'materials' ? 'material-edit' : 'academy-edit',
            params: { id: this.scheduleEntityId } });
        }
      }
    },
  },
};
